import React, { useState, useEffect } from 'react'
import { alertActions, regisActions } from '../../../store/actions'
import history from '../../../route/history'
import { connect } from 'react-redux'
import $ from "jquery";
import {regConstants, regisConstants} from "../../../store/constants";
import validPassword from "../../../hook/valid/password";

const RegisSimpleInput = (props) => {
    const [isLink, setIsLink] = useState(false)
    const [state, setState] = useState({
        //checkedJoinFlag: '',
        userInfo: props.location.state?.userInfo,
            // {memberName: '이수빈',
            // groupName: '아아아',
            // groupRegistno: '1313131313',
            // mobileNo: '01063737605',
            // email: 'EMPTY',
            //     bplcCd:'B552753',
            // },

    })

    const [userInfo, setUserInfo] = useState(
        state.userInfo,
    )

    useEffect(() => {

        setIsLink(true)
        console.log('연계간편기업회원')

        $(".mem_form").hide()

    }, [])

    /*** 정보일치 확인 체크 이벤트 ***/
    const checkHandler = (e) => {
        const { id, checked } = e.target

        if (id === 'infoCheck' && $("#infoCheck").is(':checked')) {
            $(".man_info").hide()
            $(".mem_form").show()
        } else {
            /*** 필수항목 전체 미동의 로직 추가 구현 필요(상태값)***/
            $(".man_info").show()
            $(".mem_form").hide()
        }
    }

    /**
     * 가입용 사용자정보
     * @param e
     */
    const handleChange = (e) => {
        const { id, value } = e.target

        setUserInfo({
            ...userInfo,
            [id]: value,
        })
    }

    //담당자 중복체크 콜백
    useEffect(() => {
        if (props.checkedId === true) {
            props.success({
                title: '담당자 아이디',
                message: '사용 가능한 아이디입니다.',
            })
            $("#idCheck").hide()
        } else {
            $("#idCheck").show()
        }
    }, [props.checkedId])

    //담당자 아이디 정보 갱신
    useEffect(() => {
        if (props.checkedId === true) {
            props.checkResetId()    // checkedId 값 false로 초기화(아이디 변경 시 중복체크를 재진행하기 위함)
        }
    }, [userInfo?.memberId])

    /**
     * 아이디 중복체크
     * 패스워드 유효성 체크
     * @param key :사업자아이디, 이용자 아이디
     * @param value
     */
    const validId = (key, value) => {
        if (key === 'memberId') {
            if (value?.length === undefined) {
                return props.error({ message: '담당자 아이디를 입력하세요.' })
            }
            if (value?.length < 4) {
                return props.error({ message: '아이디는 최소 4자리 이상입니다.' })
            }
            if (!props.checkedId) {
                (regConstants.id).test(value) ? props.checkMemberId(value) : props.error({ message: "담당자 아이디는 4~30자 영어 대소문자, 숫자만 입력 가능합니다." })
            }
        }
    }


    //가입완료처리
    useEffect(() => {
        if (props.isJoin === true) {
            history.push({ pathname: '/regis/simpleComplete', state: { memberName: userInfo.memberName, memberId: userInfo.memberId }})
        }
    }, [props.isJoin])
    
    const goNext = () => {
        // let message = ''
        // Object.keys(state).forEach((key) => {
        //     if (state[key].require === true && state[key].agree !== true) {
        //         message += state[key].title + ', '
        //     }
        // })
        //
        // if (message.length <= 0) {
        //     //var personalInfo = '/' + String(userInfo?.groupName) + '/' + userInfo?.groupRegistno + '/' + userInfo?.memberName + '/' + userInfo?.mobileNo
        //     history.replace({
        //         pathname: isLink ? '/regis/simpleComplete' : '/',
        //         state: { userInfo: state },
        //     })
        // }

        if(!userInfo?.memberId || userInfo?.memberId?.length <= 0) {
            return props.error({
                message: '담당자 아이디를 입력해주시기 바랍니다.'
            })
        }
        if (!props.checkedId) {
            return props.error({ message: '담당자 아이디 중복체크를 해주시기 바랍니다.' })
        }

        let pwdError = validPassword({ password: userInfo.passwd, id: userInfo.memberId })
        if (pwdError && pwdError?.length > 0) {
            return props.error({
                message: pwdError
            })
        }
        if(!userInfo?.passwdAgain || userInfo?.passwdAgain?.length <= 0) {
            return props.error({
                message: '\'비밀번호 확인\'란을 입력해주시기 바랍니다.'
            })
        }

        if (userInfo.passwd !== userInfo.passwdAgain) {
            return props.error({ message: '비밀번호가 일치하지 않습니다.\n 다시 확인해주세요.' })
        }
        props.registSimpleManager(userInfo)
    }

    return (
        <React.Fragment>

            <div className="wrapper">

                <div className="container">
                    <div className="top_bar">
                        <a href="#" className="anchor"><img src={require('../../../assets/images/sub/ico_back_.png')} alt="뒤로가기" /></a>
                    </div>
                    <h3 className="sub_tit">전자문서지갑 회원가입</h3>
                    <div className="sub_stit">
                        <span className="blue">본인인증이 완료되었습니다.</span><br />
                        아이디와 비밀번호를 설정하세요.
                    </div>

                    <div className="man_info">
                        <div className="t1">고객정보</div>
                        <div className="mi_item">
                            <div className="th">성명</div>
                            <div className="td">{state.userInfo.memberName}</div>
                        </div>
                        <div className="mi_item">
                            <div className="th">휴대전화번호</div>
                            <div className="td">{state.userInfo.mobileNo}</div>
                        </div>
                        {/*이메일 항목 추가*/}
                        {state.userInfo.email? state.userInfo.email != 'EMPTY' ? <div className="mi_item">
                            <div className="th">이메일</div>
                            <div className="td">{state.userInfo.email}</div>
                        </div> : null : null}

                        <div className="mi_item">
                            <div className="th">회사명</div>
                            <div className="td">{state.userInfo.groupName}</div>
                        </div>
                        <div className="mi_item">
                            <div className="th">사업자번호</div>
                            <div className="td">{state.userInfo.groupRegistno}</div>
                        </div>
                        <div className="mi_item">
                            <div className="th">시험인증신청</div>
                            <div className="td">{state.userInfo.bplcCd == 'B552693' ? '한국건설생활환경시험연구원' :
                                state.userInfo.bplcCd == 'B552753' ? '한국기계전기전자시험연구원' :
                                    state.userInfo.bplcCd == 'B552691' ? '한국화학융합시험연구원' : ''} </div>

                        </div>
                    </div>

                    <div className="all_agree mar">
                        <div className="icheck light">
                            <input type="checkbox" name="infoCheck" id="infoCheck" value="" onChange={checkHandler}/>
                            <label htmlFor="infoCheck">위 고객정보가 일치함을 확인하였습니다.</label>
                        </div>
                    </div>

                    <div className="mem_form">

                        <div className="mi_input dubtn mar">
                            <label htmlFor="mem_id" className="lab">ID</label>
                            <input type="text" name="memberId" id="memberId" className="input" maxLength="50"
                                   placeholder="아이디 입력" onChange={handleChange} />
                                <a href="#" id="idCheck" className="du" onClick={() => validId('memberId',$("#memberId").val())}>중복체크</a>
                        </div>

                        <div className="mi_input mar">
                            <label htmlFor="mem_pw" className="lab">비밀번호</label>
                            <input type="password" name="passwd" id="passwd" className="input" maxLength="50"
                                   placeholder="비밀번호 입력" onChange={handleChange} />
                        </div>
                        <div className="mi_input">
                            <label htmlFor="mem_pw" className="lab">비밀번호 확인</label>
                            <input type="password" name="passwdAgain" id="passwdAgain" className="input" maxLength="50"
                                   placeholder="비밀번호 다시 입력" onChange={handleChange} />
                        </div>
                        <div className="agree_caution mar">
                            영문, 숫자, 특수문자 중 2종류를 조합 10~16자 <br />(3종류 8~16자리)로 설정
                        </div>
                    </div>
                </div>

                <div className="btn_area">
                    <button type="button" className="btn btn-blue" onClick={goNext}>가입하기</button>
                </div>

            </div>
        </React.Fragment>
    )
}

const mapStateToProps = (state) => {
    return {
        user: state.regis,
        checkedId: state.regis.checkedId,
        isJoin: state.regis.isJoin,
    }
}

const actionCreators = {
    checkMemberId: regisActions.checkMemberId,  //아이디 중복 체크
    checkResetId: regisActions.checkResetId,    //아이디 변경 입력 시 중복체크를 위한 중복체크 상태값 초기화(checkedId : false) 함수
    registSimpleManager: regisActions.registSimpleManager,  // 가입
    success: alertActions.success,
    error: alertActions.error,
}

export default connect(mapStateToProps, actionCreators)(RegisSimpleInput)
